import React from 'react';
import { ABOUT_PAGE } from '../mock';
import Reveal from './Reveal';

const Humanity = () => {
  const { humanity } = ABOUT_PAGE;
  return (
    <section className="bg-ink">
      <div className="grid lg:grid-cols-2">
        {/* Photo */}
        <div className="relative min-h-[50vh] overflow-hidden lg:min-h-0">
          <img
            src={humanity.image}
            alt="Kanwal with school children"
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 ease-out hover:scale-[1.03]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
        </div>

        {/* Text */}
        <div className="flex items-center px-6 py-14 md:px-14 md:py-20 xl:px-24">
          <div>
            <Reveal>
              <h2 className="font-serif text-3xl font-light leading-tight tracking-[0.05em] text-white md:text-4xl xl:text-[2.8rem]">
                A HEART FOR
                <br />
                HUMANITY
              </h2>
            </Reveal>
            <Reveal delay={150}>
              <div className="mt-6 h-px w-12 bg-gold" />
            </Reveal>
            <Reveal delay={250}>
              <div className="mt-8 max-w-md space-y-5">
                {humanity.paragraphs.map((p) => (
                  <p key={p} className="text-base leading-relaxed text-neutral-300">
                    {p}
                  </p>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Humanity;
